<div class="modal-header">
    <h5 class="modal-title">Bulk Upload {{ entityTypeName }} Icons</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
    <div *ngIf="!uploadResult" class="upload-section text-center p-4">
        <p class="mb-3">Upload a ZIP file containing the icons and a CSV file mapping them.</p>

        <div class="alert alert-info text-start mb-4" style="font-size: 0.9rem;">
            <h6 class="alert-heading"><i class="bi bi-info-circle-fill me-2"></i>ZIP File Structure:</h6>
            <ul class="mb-0 ps-3">
                <li><strong>CSV file:</strong> Place at the root of the ZIP (e.g., <code>metadata.csv</code>).</li>
                <li><strong>icons folder:</strong> Create a folder named <code>icons</code> at the root.</li>
                <li><strong>Icon files:</strong> Place all images inside the <code>icons</code> folder.</li>
            </ul>
            <hr>
            <p class="mb-0 small" *ngIf="entityType === 1"><strong>CSV Columns:</strong> <code>Department</code>,
                <code>IconFileName</code></p>
            <p class="mb-0 small" *ngIf="entityType === 2"><strong>CSV Columns:</strong> <code>Department</code>,
                <code>Category</code>, <code>Subcategory</code>, <code>IconFileName</code></p>
        </div>

        <div class="d-flex justify-content-center gap-3 mt-3">
            <button class="btn btn-outline-primary" (click)="downloadTemplate()">
                <img src="/assets/images/company-management/downloadIcon.svg" class="me-2" style="width: 16px;" />
                Download CSV Template
            </button>
            <button class="btn btn-primary" (click)="triggerFileInput()">
                <img src="/assets/images/pajamas_import.svg" class="me-2"
                    style="width: 16px; filter: brightness(0) invert(1);" />
                Select ZIP File
            </button>
        </div>
        <input #fileInput type="file" accept=".zip" class="d-none" (change)="onFileSelected($event)" />

        <div *ngIf="selectedFile" class="mt-3">
            <span class="badge bg-info text-dark p-2" style="font-size: 0.9rem;">
                <i class="bi bi-file-earmark-zip me-2"></i>
                {{ selectedFile.name }}
                <i class="bi bi-x-circle ms-2 cursor-pointer" (click)="resetFileInput()" title="Remove file"></i>
            </span>
        </div>
    </div>

    <div *ngIf="loading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Uploading and processing icons...</p>
    </div>

    <div *ngIf="uploadResult" class="result-section">
        <div class="summary-cards d-flex justify-content-between mb-3">
            <div class="card bg-light p-2 text-center flex-fill mx-1">
                <small>Total</small>
                <strong>{{ uploadResult.totalRows }}</strong>
            </div>
            <div class="card bg-success-subtle p-2 text-center flex-fill mx-1">
                <small>Success</small>
                <strong class="text-success">{{ uploadResult.successfulRows }}</strong>
            </div>
            <div class="card bg-danger-subtle p-2 text-center flex-fill mx-1">
                <small>Failed</small>
                <strong class="text-danger">{{ uploadResult.failedRows }}</strong>
            </div>
        </div>

        <div class="table-responsive" style="max-height: 300px;">
            <table class="table table-sm align-middle">
                <thead class="sticky-top bg-white">
                    <tr>
                        <th>Row</th>
                        <th>Entity Name</th>
                        <th>File Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of uploadResult.items">
                        <td>{{ item.rowNumber }}</td>
                        <td>{{ item.entityName }}</td>
                        <td>{{ item.iconFileName }}</td>
                        <td>
                            <span *ngIf="item.status === BulkUploadStatus.Success" class="text-success">
                                <img src="/assets/images/company-management/greenCheck.svg" style="width: 16px;" />
                                Success
                            </span>
                            <span *ngIf="item.status === BulkUploadStatus.Failed" class="text-danger"
                                [matTooltip]="item.errorMessage || 'Unknown error'">
                                <img src="/assets/images/company-management/redError.svg" style="width: 16px;" /> Failed
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
    <button *ngIf="selectedFile && !uploadResult" type="button" class="btn btn-primary" [disabled]="loading"
        (click)="uploadIcons()">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        Start Upload
    </button>
</div>